// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */
// @ts-nocheck
import type * as Types from '@/graphql/schema';

import useSubscription from '@/client/hooks/useSubscription';
import gql from '@/graphql/gql';
import { NotificationFragmentDoc } from '../../../../../../../graphql/notifications/NotificationFragment.generated';
export type NotificationAddedSubscriptionVariables = Types.Exact<{
  input: Types.CasinoNotificationNormalNotificationAddedSubscriptionInput;
  language?: Types.InputMaybe<Types.Scalars['String']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
  deviceType?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  userCurrency?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type NotificationAddedSubscription = { __typename?: 'Subscription', casinoNotificationNormalNotificationAdded?: { __typename?: 'CasinoNotificationNormalNotificationAddedSubscriptionPayload', clientSubscriptionId?: string, addedNotification?: { __typename?: 'CasinoNotificationNormalNotificationEdge', node?: { __typename?: 'CasinoNotificationNormalNotification', id: string, createTime?: number, isRead?: boolean, type?: string, title?: string, body?: string, link?: string, icon?: string, contentType?: string } } } };


export const NotificationAddedSubscriptionDocument = gql`
    subscription NotificationAddedSubscription($input: CasinoNotificationNormalNotificationAddedSubscriptionInput!, $language: String, $locale: String, $deviceType: Int, $userCurrency: String) {
  casinoNotificationNormalNotificationAdded(input: $input) {
    addedNotification {
      node {
        id
        ...NotificationFragment
      }
    }
    clientSubscriptionId
  }
}
    ${NotificationFragmentDoc}`;

export const useNotificationAddedSubscription = (options: { variables?: NotificationAddedSubscriptionVariables, onData: (data: NotificationAddedSubscription) => void } ) => { 
  return useSubscription<NotificationAddedSubscription, NotificationAddedSubscriptionVariables>(NotificationAddedSubscriptionDocument, options);
}